module.exports = __webpack_public_path__ + "static/media/Optix_logo_2.becaa86a.png";